export const SET_EVENTS = 'STATUS/SET_EVENTS';
export const START_CHANGE_STATUS = 'STATUS/START_CHANGE_STATUS';
export const DONE_CHANGE_STATUS = 'STATUS/DONE_CHANGE_STATUS';
export const STATUS_UPDATED = 'STATUS/STATUS_UPDATED';
export const SET_SUMMARY = 'STATUS/SET_SUMMARY'
export const SET_HOLIDAYS_SUMMARY = 'STATUS/SET_HOLIDAYS_SUMMARY';
export const SET_USER_DETAILS = 'STATUS/SET_USER_DETAILS';